"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_uid_1 = require("react-uid");
const videoStyles_1 = require("../../styling/videoStyles");
const selectStyles_1 = tslib_1.__importDefault(require("./selectStyles"));
const ChevronDown_1 = tslib_1.__importDefault(require("../Icons/ChevronDown"));
const Select = (0, react_1.forwardRef)(({ ariaLabel, classes = { root: {}, select: {}, label: {} }, label, children, onChange, value, tag, ...rest }, ref) => {
    const { root: rootClass, select: selectClass, label: labelClass, selectContainer: selectContainerClass, icon: iconClass, } = (0, videoStyles_1.useStyles)({ source: classes, target: selectStyles_1.default }, "select");
    const uid = (0, react_uid_1.useUID)();
    return (react_1.default.createElement("div", { className: rootClass },
        label != null ? (react_1.default.createElement("label", { htmlFor: uid, className: labelClass }, label)) : null,
        react_1.default.createElement("div", { className: selectContainerClass },
            react_1.default.createElement("select", { ref: ref, id: uid, className: selectClass, "aria-label": label !== null && label !== void 0 ? label : "Default select", "data-selenium": tag !== null && tag !== void 0 ? tag : "select-input", onChange: onChange, value: value }, children),
            react_1.default.createElement(ChevronDown_1.default, { className: iconClass }))));
});
exports.default = Select;
//# sourceMappingURL=Select.js.map